import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const rowDesktopNoWrapIsDesktopUpCss = "rksm6hs";
const rowDesktopNoWrapCss = "r10o534g";
export const RowDesktopNoWrap = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(rowDesktopNoWrapCss, {
    [rowDesktopNoWrapIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const rowActionButtonWrapperCss = "rfzvcf9";
export const RowActionButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowActionButtonWrapperCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");